import React, { useEffect, useState } from 'react'
import { donwload, ios, win } from "@/assets/workbenchimage";
import { getDownList } from '@/services/createSpace/engineering';
import "./index.less"
import { AiModal } from '@/components/AiFactory';
export default function index({ visible, setVisible }) {
  const [downList, setDownList] = useState([
    {
      label: "Windows10及以上",
      path: "https://prod.cdn-pub.zxaigc.com/public/download/factory/ai-dream-factory-1.6.6.exe",
      icon: win,
    },
    {
      label: "MacOS",
      path: "https://zhaixing-prod-00.oss-cn-shanghai.aliyuncs.com/public/download/video_post_v1.4.2.dmg",
      icon: ios,
    },
  ]);
  const handleDownList = async () => {
    const res = await getDownList()
    if (res && Object.keys(res?.data).length) {
      const { mac, win } = JSON.parse(res.data)
      const newList = [...downList]
      newList[0].path = win
      newList[1].path = mac
      setDownList(newList)
    }
  }
  useEffect(() => {
    if (visible) {
      handleDownList()
    }
  }, [visible])
  return (
    <AiModal
      title="请选择要安装的客户端版本"
      visible={visible}
      showFooter={false}
      onCancel={() => setVisible(false)}>
      <div
        className="auth-modal-box"
      >
        {downList.map((item, index) => {
          return (
            <div className="auth-item" key={index}>
              <div className="auth-item-img">
                <img
                  style={{ marginBottom: "21px" }}
                  width={58}
                  height={58}
                  src={item.icon}
                />
                <div className="title">{item.label}</div>
              </div>
              <a href={item.path} className="auth-down">
                <img
                  style={{ marginRight: "11px" }}
                  color={"#ffffff"}
                  width={20}
                  height={20}
                  src={donwload}
                />
                立即安装
              </a>
            </div>
          );
        })}
      </div>
    </AiModal>
  )
}
